import * as React from "react";
const SvgFiRrEyeDropperHalf = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-eye-dropper-half_svg__a)">
      <path
        fill="#062147"
        d="M23.112 5.165a3 3 0 0 0 .89-2.14A3.025 3.025 0 0 0 18.84.885l-2.439 2.438c-1.013 1.013-3.124.79-4.58-.015-.99-.543-2.246-.353-3.057.459a2.6 2.6 0 0 0-.764 1.843c0 .697.271 1.35.764 1.844l1.416 1.416-8.156 8.155a3.51 3.51 0 0 0-.604 4.139L.292 22.293a.999.999 0 1 0 1.414 1.414l1.127-1.127c.506.274 1.074.42 1.666.42.935 0 1.814-.364 2.475-1.025l8.155-8.154 1.416 1.416a2.59 2.59 0 0 0 1.843.764c.696 0 1.351-.271 1.843-.764.814-.812 1.002-2.07.458-3.058-.8-1.456-1.025-3.567-.012-4.58zM5.56 20.56c-.565.566-1.554.566-2.12 0a1.503 1.503 0 0 1 0-2.121L5.877 16h4.243zM12.122 14H7.88l3.715-3.715 2.122 2.122zm7.141-7.814c-1.759 1.758-1.496 4.83-.325 6.958.117.213.068.49-.12.679a.62.62 0 0 1-.857 0l-7.78-7.781a.6.6 0 0 1-.179-.43c0-.162.063-.314.178-.43A.6.6 0 0 1 10.61 5c.086 0 .172.02.25.062 2.126 1.17 5.198 1.436 6.957-.324L20.255 2.3a1.026 1.026 0 0 1 1.447 0c.194.193.3.45.3.725s-.107.53-.3.725z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-eye-dropper-half_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrEyeDropperHalf;
